'use strict';

var _classCallCheck = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _isNativeReflectConstruct = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/isNativeReflectConstruct");
var _getPrototypeOf = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _get = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _inherits = require("/sites/producao/gestaotecnologica/gestec-v2-client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
var ErrorReportingMixinBase = require('./mixin-base');
var PositionTrackingPreprocessorMixin = require('../position-tracking/preprocessor-mixin');
var Mixin = require('../../utils/mixin');
var ErrorReportingPreprocessorMixin = /*#__PURE__*/function (_ErrorReportingMixinB) {
  function ErrorReportingPreprocessorMixin(preprocessor, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingPreprocessorMixin);
    _this = _callSuper(this, ErrorReportingPreprocessorMixin, [preprocessor, opts]);
    _this.posTracker = Mixin.install(preprocessor, PositionTrackingPreprocessorMixin);
    _this.lastErrOffset = -1;
    return _this;
  }
  _inherits(ErrorReportingPreprocessorMixin, _ErrorReportingMixinB);
  return _createClass(ErrorReportingPreprocessorMixin, [{
    key: "_reportError",
    value: function _reportError(code) {
      //NOTE: avoid reporting error twice on advance/retreat
      if (this.lastErrOffset !== this.posTracker.offset) {
        this.lastErrOffset = this.posTracker.offset;
        _superPropGet(ErrorReportingPreprocessorMixin, "_reportError", this, 3)([code]);
      }
    }
  }]);
}(ErrorReportingMixinBase);
module.exports = ErrorReportingPreprocessorMixin;